<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="VMS Template Management" />
    </div>

    <!-- Search and Create new package -->
    <div class="row mb-2">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <b-form-input
              type="search"
              class="form-control"
              placeholder="Search VMS"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showAddVmsModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i>
            {{ $t("menuitems.administration.list.vmsGroup.list.add") }}
          </button>
        </div>
      </div>
    </div>
    <!-- Company Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allVmsDevices"
        :fields="fields"
        responsive="sm"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #cell(created_at)="row">
          <span
            >{{ new Date(row.item.created_at).toDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="showUpdateVmsModal(row.item)"
          >
            Edit
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            @click="deleteVmsDevice(row.item)"
          >
            Delete
          </b-button>
        </template>
      </b-table>
    </div>

    <!-- Create vms modal -->
    <b-modal
      id="create-new-vms-modal"
      title="Add New VMS Device"
      no-close-on-backdrop
      hide-footer
      size="lg"
    >
      <template #modal-header>
        <div><h5>Add New VMS Device</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="closeAddNewModal()"
          >
            Cancel
          </button>
        </div>
      </template>

      <form @submit.prevent="addNewVMSDevice">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">VMS Name</th>
                        <td>
                          <input
                            placeholder="Enter VMS Name"
                            v-model="vmsName"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS IP</th>
                        <td>
                          <input
                            placeholder="Enter VMS IP"
                            v-model="vmsIp"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Chainage</th>
                        <td>
                          <input
                            placeholder="Enter/ Paste Chainage"
                            v-model="vmsChainage"
                            type="text"
                            class="form-control inp-bg"
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Package</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsPackage"
                            :options="options.packages"
                            :reduce="(packages) => packages.id"
                            label="package_name"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Direction</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsDirection"
                            :options="options.direction"
                            required
                          ></v-select>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Type</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsType"
                            :options="options.type"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS Make</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsMake"
                            :options="options.makes"
                            required
                          ></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VMS Model</th>
                        <td>
                          <v-select
                            class="style-chooser"
                            v-model="vmsModel"
                            :options="options.models"
                            required
                          ></v-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Add VMS Device <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Edit and Update VSDS -->
    <b-modal
      id="edit-vsds-modal"
      title="Create New Company"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      size="lg"
    >
      <template #modal-header>
        <div><h5>Add New VSDS</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('edit-vsds-modal')"
          >
            Cancel
          </button>
        </div>
      </template>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">VSDS Name</th>
                      <td>
                        <input
                          placeholder="Enter VSDS Name"
                          v-model="selectedVmsDevice.vms_name"
                          type="text"
                          class="form-control inp-bg"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">VSDS URL</th>
                      <td>
                        <input
                          placeholder="Enter/ Paste VSDS URL"
                          v-model="selectedVmsDevice.vms_ip"
                          type="text"
                          class="form-control inp-bg"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Integrator Company</th>
                      <td>
                        <v-select
                          class="style-chooser"
                          v-model="selectedVmsDevice.company_name"
                          :options="companyNames"
                          :reduce="(company) => company.id"
                          label="company_name"
                        ></v-select>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Package</th>
                      <td>
                        <v-select
                          class="style-chooser"
                          v-model="selectedVmsDevice.package"
                          :options="options.packages"
                          :reduce="(packages) => packages.id"
                          label="package_name"
                        ></v-select>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Direction</th>
                      <td>
                        <v-select
                          class="style-chooser"
                          v-model="selectedVmsDevice.direction"
                          :options="options.direction"
                        ></v-select>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Chainage</th>
                      <td>
                        <input
                          placeholder="Enter/ Paste Chainage"
                          v-model="selectedVmsDevice.vmsChainage"
                          type="text"
                          class="form-control inp-bg"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">No. of Cameras</th>
                      <td>
                        <input
                          placeholder="Enter Number of Cameras"
                          v-model="selectedVmsDevice.camera"
                          type="number"
                          class="form-control inp-bg"
                          required
                        />
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">No of Speed Radars</th>
                      <td>
                        <input
                          placeholder="Enter Number of Speed-Radars"
                          v-model="selectedVmsDevice.speed_radar"
                          type="number"
                          class="form-control inp-bg"
                          required
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <form @submit.prevent="updateVmsDevice">
        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Update VSDS Location <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import vsdsMixin from "../../mixins/administration";
import incidentMixin from "../../mixins/incident";

import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "VMS Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [vsdsMixin, incidentMixin],

  data() {
    return {
      allVmsDevices: [],
      companyTypes: [],
      companyNames: [],

      vmsName: null,
      vmsIp: null,
      vmsPackage: null,
      vmsDirection: null,
      vmsChainage: null,
      vmsMake: null,
      vmsModel: null,
      vmsType: null,

      company: null,
      cameras: null,
      speedRadars: null,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      selectedVmsDevice: {},
      options: {
        direction: ["LHS", "RHS"],
        type: ["Cantilever", "Full"],
        models: ["Test 1"],
        makes: ["Test 2"],
        packages: [],
      },
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "vms_name",
          label: "VMS Name",
          sortable: false,
        },
        {
          key: "vms_ip",
          label: "VMS IP",
          sortable: false,
        },
        {
          key: "chainage",
          label: "Chainage",
          sortable: false,
        },
        {
          key: "package",
          label: "Package",
          sortable: false,
        },
        {
          key: "direction",
          label: "Direction",
          sortable: false,
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key: "model",
          label: "Model",
          sortable: false,
        },
        {
          key: "make",
          label: "Make",
          sortable: false,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    showAddVmsModal() {
      this.$bvModal.show("create-new-vms-modal");
    },

    showUpdateVmsModal(vmsData) {
      this.selectedVmsDevice = vmsData;
      this.$bvModal.show("edit-vsds-modal");
    },

    closeAddNewModal() {
      this.vmsName = null;
      this.vmsIp = null;
      this.vmsPackage = null;
      this.vmsDirection = null;
      this.vmsChainage = null;
      this.vmsMake = null;
      this.vmsModel = null;
      this.$bvModal.hide("create-new-vms-modal");
    },

    async addNewVMSDevice() {
      try {
        let data = {
          vms_name: this.vmsName,
          vms_ip: this.vmsIp,
          package: this.vmsPackage,
          direction: this.vmsDirection,
          chainage: this.vmsChainage,
          make: this.vmsMake,
          model: this.vmsModel,
        };

        this.$store.dispatch("layout/changeLoaderValue", true);
        // await this.CreateVsds(data);
        console.log(data);
        this.vmsName = null;
        this.vmsIp = null;
        this.vmsPackage = null;
        this.vmsDirection = null;
        this.vmsChainage = null;
        this.vmsMake = null;
        this.vmsModel = null;

        // this.allVmsDevices = await this.ShowVsds();

        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("create-new-vms-modal");
        Swal.fire("VMS Added", "VMS device added successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to add VMS device", "error");
      }
    },

    async updateVmsDevice() {
      try {
        const company = this.companyNames.find(
          (data) => data.company_name === this.selectedVmsDevice.company_name
        );

        let data = {
          id: this.selectedVmsDevice.id,
          title: this.selectedVmsDevice.vms_name,
          link: this.selectedVmsDevice.vms_ip,
          company: company.id,
          package: this.selectedVmsDevice.package,
          direction: this.selectedVmsDevice.direction,
          vmsChainage: this.selectedVmsDevice.vmsChainage,
          camera: this.selectedVmsDevice.camera,
          speed_radar: this.selectedVmsDevice.speed_radar,
        };
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateVsds(data);
        this.selectedVmsDevice = {};
        this.allVmsDevices = await this.ShowVsds();
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("edit-vsds-modal");
        Swal.fire("VSDS Updated", "VSDS updated successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to update VSDS", "error");
      }
    },

    async deleteVmsDevice(vsds) {
      try {
        const id = {
          id: vsds.id,
        };

        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            await this.DeleteVsds(id);
            this.allVmsDevices = await this.ShowVsds();
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to delete VSDS", "error");
      }
    },

    async getAllPackages() {
      try {
        const packages = await this.GetIncidentMasters();
        this.options.packages = packages.getPackages;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },
  },
  components: {
    Layout,
    PageHeader,
  },

  async mounted() {
    // this.allVmsDevices = await this.ShowVsds();
    this.getAllPackages();
  },
};
</script>